import React from "react";
import '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faReact, faDocker, faPython} from '@fortawesome/free-brands-svg-icons';
import { faBrain } from '@fortawesome/free-solid-svg-icons';
import Chip from '@mui/material/Chip';
import '../assets/styles/Expertise.scss';

const labelsFirst = [
    "Python",
    "SQL",
    "Pandas",
    "NumPy",
    "Scikit-learn",
    "PyTorch",
    "R",
    "Django",
    "Flask"
]

const labelsSecond = [
    "Docker",
    "AWS",
    "Azure",
    "CI/CD",
    "ETL pipelines",
    "Linux",
    "GitHub Actions",
    "Airflow"
];

const labelsThird = [
    "Transfer-learning",
    "LlamaIndex",
    "GPT",
    "Hugging Face",
    "OpenAI",
];

function Expertise() {
    return (
    <div className="container" id="expertise">
        <div className="skills-container">
            <h1>Expertise</h1>
            <div className="skills-grid">
                <div className="skill">
                    <FontAwesomeIcon icon={faBrain} size="3x"/>
                    <h3>Machine Learning/AI Engineer </h3>
                    <p>A Machine Learning/AI Engineer with deep industry and academic expertise, specializing in time-series forecasting, NLP, and data engineering. I have built innovative, scalable AI solutions, combining research and practical implementation to deliver impactful application</p>
                    <div className="flex-chips">
                        <span className="chip-title">Tech stack:</span>
                        {labelsFirst.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>

                <div className="skill">
                    <FontAwesomeIcon icon={faDocker} size="3x"/>
                    <h3>Solution Architect & DevOps/MLOps</h3>
                    <p>An expert in DevOps and MLOps, specializing in deployment automation for scalable machine learning systems. I optimize workflows to ensure seamless Go-Live transitions and am a certified AWS Associate Solution Architect, enhancing cloud-based infrastructure and deployment strategies.</p>
                    <div className="flex-chips">
                        <span className="chip-title">Tech stack:</span>
                        {labelsSecond.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>

                <div className="skill">
                    <FontAwesomeIcon icon={faPython} size="3x"/>
                    <h3>GenAI & LLM</h3>
                    <p>Stay relevant in the market by leveraging the latest AI models in your projects. I have professional experience building enterprise grade GenAI-enabled solutions to empower intelligent decision making.</p>
                    <div className="flex-chips">
                        <span className="chip-title">Tech stack:</span>
                        {labelsThird.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    </div>
    );
}

export default Expertise;